<template>
  <div class="crypto-source-select">
    <button
      v-for="item in list"
      :key="item"
      :disabled="item.isDisabled"
      class="crypto-source-select__item"
      :class="{
        'crypto-source-select__item--active': item.value === props.value,
        'crypto-source-select__item--disabled' : item.isDisabled,
      }"
      @click="onSelect(item.value)"
    >
      <Icon :icon="item.icon"/>
      {{ item.label }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import Icon from '@paybis/frontend-common-lib/src/components/icon.vue';

import { i18n } from '@/i18n';
import { WalletTypes } from '@/types';


const props = defineProps<{
  value: WalletTypes,
  isPaybisWalletAvailable: boolean
}>();

interface Options {
  label: string;
  icon: string;
  value: WalletTypes;
  isDisabled: boolean;
}

const list: Options[] = [
  {
    label: i18n.t('exchange-form.tabs.paybis-wallet').toString(),
    icon: 'paybis-logo',
    value: WalletTypes.PAYBIS,
    isDisabled: !props.isPaybisWalletAvailable,
  },
  {
    label: i18n.t('exchange-form.tabs.external-wallet').toString(),
    icon: 'wallet',
    value: WalletTypes.EXTERNAL,
    isDisabled: false,
  },
];

const emit = defineEmits<{
  (e: 'input', value: WalletTypes): void,
}>();

const onSelect = (value: WalletTypes) => {
  if (props.value === value) {
    return;
  }

  emit('input', value);
};
</script>

<style lang="scss" scoped>
@import "@scss-vars";

.crypto-source-select {
  display: flex;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
  white-space: nowrap;
  border-radius: 6px;

  @media screen and (max-width: $screen-lg-min) {
    padding-top: 8px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: $font-bold;
    font-size: rem(16);
    line-height: rem(24);
    padding: 4px 10px;
    border-radius: 4px;
    transition: color 0.15s;

    &:hover {
      color: $black-48;
    }

    &--active {
      background-color: $black;
      color: $white;

      &:hover {
        color: $white;
      }
    }

    &--disabled {
      color: $black-56;
      cursor: auto;
    }
  }
}
</style>
